import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "suffix", "input"]
  static values = {
    units: Object,
    conversionFactor: Number
  }

  updateUnit(event) {
    const countryId = event.target.value
    if (!countryId) return

    const newUnit = this.unitsValue[countryId]
    if (!newUnit) return

    const currentUnit = this.hasSuffixTarget ? this.suffixTarget.textContent.trim() : null

    if (this.hasInputTarget && currentUnit && currentUnit !== newUnit && this.inputTarget.value !== "") {
      const currentValue = parseFloat(this.inputTarget.value)

      if (!isNaN(currentValue)) {
        if (currentUnit === "KM" && newUnit === "MI") {
          this.inputTarget.value = Math.round(currentValue / this.conversionFactorValue)
        } else if (currentUnit === "MI" && newUnit === "KM") {
          this.inputTarget.value = Math.round(currentValue * this.conversionFactorValue)
        }
      }
    }

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = newUnit
    }

    if (this.hasSuffixTarget) {
      this.suffixTarget.textContent = newUnit
    }
  }
}
